module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("3DEes"))).then(() => parcelRequire('hEqeo'));